/** @jsxImportSource theme-ui */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RisksProjectionCard } from 'components/RisksProjectionCard';

import { setSelectedListRiskType } from 'diseaseActivitiesInCountryLocations/diseaseActivitiesInCountryLocations.slice';
import diseaseActivityListSelectors from 'diseaseActivitiesInCountryLocations/diseaseActivityList.selectors';

type RiskCardForDiseaseProps = {
  isRiskParametersSelected?: boolean;
};

const RiskCardForDisease: React.FC<RiskCardForDiseaseProps> = ({
  isRiskParametersSelected = false,
}) => {
  const dispatch = useDispatch();
  const importationRisk = useSelector(diseaseActivityListSelectors.importationRisk);
  const exportationRisk = useSelector(diseaseActivityListSelectors.exportationRisk);
  const outbreakPotentialCategory = useSelector(
    diseaseActivityListSelectors.outbreakPotentialCategory
  );
  const diseaseInformation = useSelector(diseaseActivityListSelectors.diseaseInformation);
  const selectedRiskType = useSelector(diseaseActivityListSelectors.selectedRiskType);

  return (
    <RisksProjectionCard
      importationRisk={importationRisk}
      exportationRisk={exportationRisk}
      outbreakPotentialCategory={outbreakPotentialCategory}
      diseaseInformation={diseaseInformation}
      onClick={
        // TODO: open transpar panel on this click based on condition
        // !selectedRisk?.isModelNotRun && !selectedRisk?.isModelRunning
        undefined
      }
      isSelected={isRiskParametersSelected}
      riskType={selectedRiskType}
      onRiskTypeChanged={riskType => dispatch(setSelectedListRiskType(riskType))}
    />
  );
};

export default RiskCardForDisease;
